import React from 'react';
import Overview from './Overview';

class OverviewView extends React.Component {
    render() {
        return <Overview />;
    }
}

export default OverviewView;
